import React from 'react'
import TextRender from '../../texteditor/TextRender'

import {
  ILayout_Render,
  ILayout_Cell_Props_Text,
} from '@kaidam/fc-shared/src/types/layout'

/*

  RENDER

*/
const TextComponent: ILayout_Render<ILayout_Cell_Props_Text> = ({
  cell,
}) => {
  const horizontalAlign = cell.config?.horizontal_align
  const value = cell.data.text
  return (
    <TextRender
      value={ value }
      horizontalAlign={ horizontalAlign }
      padding={ 0 }
    />
  )
}

export default TextComponent